import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Navbar from '../../layout/Navbar/Navbar';
import Sidebar from '../../layout/Sidebar/Sidebar';
import { getCargoIdSidebar } from '../../../constants/sidebarConfig';
import apiService from '../../../services/api';

const Pagina = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
`;

const Corpo = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const Conteudo = styled.main`
  flex: 1;
  margin-left: 300px;
  overflow-y: auto;
  height: calc(100vh - 60px);
`;

const PaginaRelatorio = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [itensDoMenu, setItensDoMenu] = useState([]);

  useEffect(() => {
    apiService
      .getCurrentUser()
      .then((dados) => {
        setUsuario(dados);
        setItensDoMenu(getCargoIdSidebar(dados.cargoId) || []);
      })
      .catch((erro) => console.error('Erro ao buscar usuário:', erro));
  }, []);

  return (
    <Pagina>
      <Navbar onLogout={apiService.logout} showHome showNotifications showProfile showLogout user={usuario} />
      <Corpo>
        <Sidebar items={itensDoMenu} />
        <Conteudo>{children}</Conteudo>
      </Corpo>
    </Pagina>
  );
};

export default PaginaRelatorio;
